/**
 * ./src/warmup/warmup1.js
 * 
 * 
 */


import React, { useState, useEffect } from "react";
import { useNavigate , useLocation} from "react-router-dom"; // useNavigate instead of useHistory
import "../exercise1/Exercise1.css";
import Curtain from "../components/Curtain"; // Import the reusable Curtain component
import persongreyIcon from "../exercise1/icons/person-grey.svg"; // Import the person icon

const Warmup1 = () => {
  const location = useLocation();
  const exerciseNumber = location.state?.exerciseNumber;
  const [isCurtainActive, setIsCurtainActive] = useState(true);
  const [isExiting, setIsExiting] = useState(false);
  const navigate = useNavigate(); // Create a navigate function for navigation

  useEffect(() => {
    // Timer for curtain
    const curtainTimer = setTimeout(() => {
      setIsCurtainActive(false);
    }, 2000); // 2 seconds

    return () => {
      clearTimeout(curtainTimer);
    };
  }, [navigate]);

  return (
    <>
      <div className={`exercise1-page ${isExiting ? "fade-out" : ""}`}>
        {/* Display the curtain and set it to "disappear" */}
        {isCurtainActive && <Curtain disappear={true} duration={2000} />}

        {/* Text content */}
        <div className="exercise1-header">
          <h1>Warmup 1: Rhythmic Breathing</h1>
        </div>

        {/* Blue bottom area */}
        <div className="exercise1-bottom">
          <img
            className="exercise1-person"
            src={persongreyIcon}
            alt="Person Grey Icon"
          />
          <button
            className="start-exercise"
            onClick={() => {
              navigate("/exercise1workout", { state: { exerciseNumber: exerciseNumber,
                duration: 0.25, isWarmup: true} });
              setIsExiting(true);
            }}
          >
            <b>START</b>
          </button>
        </div>
      </div>
      <div className={`page-transition ${isExiting ? "fade-in" : ""}`} />
    </>
  );
};

export default Warmup1;
